import React, { forwardRef, useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import Input from '../Input/Input';
import './PasswordInput.css';

// Parol maydoni: ko'rsatish/yashirish tugmasi bilan. Ko'rinish holati — faqat UI state.
// Qolgan barcha prop'lar (name, value, onChange, autoComplete, required ...) Input orqali <input> ga.
const PasswordInput = forwardRef(function PasswordInput(
  { showLabel = "Parolni ko'rsatish", hideLabel = 'Parolni yashirish', ...rest },
  ref
) {
  const [visible, setVisible] = useState(false);

  return (
    <Input
      {...rest}
      ref={ref}
      type={visible ? 'text' : 'password'}
      rightElement={
        <button
          type="button"
          className="ui-password__toggle"
          onClick={() => setVisible((x) => !x)}
          aria-label={visible ? hideLabel : showLabel}
          aria-pressed={visible}
          disabled={rest.disabled}
        >
          {visible ? <EyeOff aria-hidden="true" /> : <Eye aria-hidden="true" />}
        </button>
      }
    />
  );
});

export default PasswordInput;
